import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { catchError, EMPTY, Observable, of, timeout } from 'rxjs';
import { IS_SERVER_PLATFORM } from 'src/app/core';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(@Inject(IS_SERVER_PLATFORM) private isServer: boolean) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!!!this.isServer) {
      return next.handle(request);
    } else {
      return next.handle(request).pipe(
        timeout(1),
        catchError((err: any, caught: any) => EMPTY)
      );
    }
  }
}
